import PropTypes from "prop-types";
import { useTheme, Box, TextField } from "@mui/material";

export const ActivateForm = ({ state, setLicenseKey }) => {
  const theme = useTheme();
  const { licenseKey, errMsg } = state;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: theme.spacing(4.5),
        marginBottom: theme.spacing(10),
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
      }}
    >
      <TextField
        label="License Key"
        size="small"
        fullWidth
        InputLabelProps={{ shrink: true }}
        value={licenseKey}
        onChange={(e) => setLicenseKey(e.target.value)}
        error={!!errMsg}
        helperText={errMsg}
      />
    </Box>
  );
};
ActivateForm.propTypes = {
  state: PropTypes.object.isRequired,
  setLicenseKey: PropTypes.func.isRequired,
};
export default ActivateForm;
